import styled from 'styled-components'
import { Text } from '@doordash/design-language'

export const TermsTitle = styled(Text).attrs<{}>({
  styles: Text.Styles.Medium14,
  color: Text.Colors.TextLink,
})`
  text-decoration: underline;

  &:hover {
    cursor: pointer;
  }
`
